var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Checkbox, FormControl, FormControlLabel, FormGroup, FormHelperText, FormLabel } from "@mui/material";
import { useController, useWatch } from "react-hook-form";
import { useCurrencyLocalizer } from "../../hooks/useCurrencyLocalizer";
export const CheckboxGroup = (_a) => {
    var _b, _c, _d;
    var { max, control, label, name, options, helperText, required } = _a, rest = __rest(_a, ["max", "control", "label", "name", "options", "helperText", "required"]);
    const _e = useController({
        name,
        control,
        defaultValue: [],
    }), _f = _e.field, { ref, value, onChange } = _f, inputProps = __rest(_f, ["ref", "value", "onChange"]), { formState: { errors } } = _e;
    const checkboxIds = useWatch({ control, name: name }) || [];
    const handleChange = (value) => {
        const newArray = [...checkboxIds];
        const item = value;
        //Ensure array isnt empty
        if (newArray.length > 0) {
            //Attempt to find an item in array with matching id
            const index = newArray.findIndex((x) => x === item);
            // If theres no match add item to the array
            if (index === -1) {
                newArray.push(item);
            }
            else {
                //If there is a match and the value is empty, remove the item from the array
                newArray.splice(index, 1);
            }
        }
        else {
            //If the array is empty, add the item to the array
            newArray.push(item);
        }
        //Overwrite existing array with newArray}
        onChange(newArray);
    };
    return (_jsx(_Fragment, { children: _jsxs(FormControl, Object.assign({ required: required }, { children: [_jsx(FormLabel, Object.assign({ sx: { fontWeight: "bold", pb: 1 } }, { children: label })), _jsx(FormGroup, Object.assign({ row: true }, { children: options.map((option) => {
                        const isOptionDisabled = value.length === max && !value.includes(option.value);
                        const localizedOptionPrice = option.price ? useCurrencyLocalizer(option.price).localizedCurrencyText : "";
                        return (_jsx(FormControlLabel, { control: _jsx(Checkbox, Object.assign({ checked: value === null || value === void 0 ? void 0 : value.some((checked) => checked === option.value) }, inputProps, { inputRef: ref, onChange: () => handleChange(option.value), disabled: isOptionDisabled })), label: `${option.label} ${localizedOptionPrice}` }, option.value));
                    }) })), _jsx(FormHelperText, Object.assign({ error: (_b = !!(errors === null || errors === void 0 ? void 0 : errors[name])) !== null && _b !== void 0 ? _b : false, variant: "outlined" }, { children: (_d = (_c = errors === null || errors === void 0 ? void 0 : errors[name]) === null || _c === void 0 ? void 0 : _c.message) !== null && _d !== void 0 ? _d : helperText }))] })) }));
};
